<template>
  <div>
    <v-hover v-slot="{ hover }">
      <div :class="{ 'hoveredBackground': hover }" class="cursorPointer" @click="editFunctionalSkills">
        <v-banner class="banner-without-padding py-1" style="top:50px; z-index:1" sticky color="primary" single-line>
          <v-layout wrap>
            <v-flex xs12 class="primary white--text" text-center>
              <h3>
                <span>{{ $t('a') }}</span>
                <v-icon small class="ml-2" :class="{ 'white--text': hover, 'primary--text': !hover }">mdi-pen</v-icon>
              </h3>
            </v-flex>
          </v-layout>
        </v-banner>
        <v-divider/>
        <v-layout wrap>
          <v-flex xs12 v-if="dossier.profile.skills.functionalSkillsDescription" class="quillAsHtmlContainer" pl-1>
            <div class="quillAsHtml" v-html="dossier.profile.skills.functionalSkillsDescription"></div>
          </v-flex>
          <v-flex xs12 v-else>
            <v-layout wrap>
              <v-flex xs3></v-flex>
              <v-flex xs9 pl-2>
                <i>{{ $t('b') }}</i>
              </v-flex>
            </v-layout>  
          </v-flex>
        </v-layout>
      </div>
    </v-hover>
  </div>
</template>

<script>

export default {
  props: {
    dossier: Object
  },
  computed:{
  },
  methods: {
    editFunctionalSkills() {
      this.$emit('setFieldPath', { fieldPath: ['functionalSkills'], savedScrollEltId: `view-functionalSkills` })
    },
  }
}
</script>


<i18n>
{
  "fr": {
    "a": "Compétences fonctionnelles",
    "b": "Vide."
  },
  "en": {
    "a": "Functional skills",
    "b": "Empty."
  }
}
</i18n>